import React from 'react';

const GrievancePolicy = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-[#1b2d4a] text-white py-12">
        <div className="container mx-auto px-6">
          <h1 className="text-4xl font-bold mb-2">
            REDRESSAL OF GRIEVANCE
          </h1>
          <p className="text-gray-300">
            Our process for addressing client complaints and concerns
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <p className="text-gray-700 mb-6 text-lg">
              Here are the steps a client can follow in case of grievance or feedback:
            </p>
            
            <ul className="list-disc list-inside text-gray-700 space-y-6 marker:text-gray-500">
              <li className="leading-relaxed">
                If you are not satisfied with our services and would like to lodge a complaint, we would request you to first talk to our representative/consultant from the Research Analyst Department who is your point of contact. You can discuss with him/her, and be rest assured that your complaint will be resolved on best efforts within 5 to 10 working days.
              </li>
              <li className="leading-relaxed">
                You can also email or talk to the representative/consultant via telephone. The contact number is 9372273366
              </li>
              <li className="leading-relaxed">
                Alternatively, you can send us a complaint in writing or via email at <a href="mailto:info@climbcapital.in" className="text-blue-600 hover:underline">info@climbcapital.in</a>
              </li>
              <li className="leading-relaxed">
                We will try to resolve your complaint within 5 to 10 working days. The first step is for us to be clear about the nature of your complaint and to identify what we can do to resolve the issue. When we have finished our investigations into your complaint, we will be in touch to provide you with a full response to your complaint.
              </li>
              <li className="leading-relaxed">
                If you are still not satisfied with the response or the handling of your complaint by our representative/consultant, you can approach and write an email to Mr. Sahil J Solanki at <a href="mailto:info@climbcapital.in" className="text-blue-600 hover:underline">info@climbcapital.in</a> with complete details. Mr. Sahil J Solanki will get in touch with you at the earliest and try to resolve your complaint as soon as possible.
              </li>
              <li className="leading-relaxed">
                If your complaint is not resolved within a period of one month, you may refer your complaint to the regulator - The Securities and Exchange Board of India (SEBI).
              </li>
              <li className="leading-relaxed">
                SEBI has launched a centralized web-based complaints redress system 'SCORES'. The link to the platform is <a href="https://scores.gov.in/scores/complaintRegister.html#" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://scores.gov.in/scores/complaintRegister.html#</a>
              </li>
              <li className="leading-relaxed">
                If your complaint is not resolved on the SCORES portal, you can start the dispute resolution process through the ODR Portal. The link for the platform is <a href="https://smartodr.in/login" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://smartodr.in/login</a>.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GrievancePolicy;
